<template>
   <main class="inner-page page-auth">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-11">
            <div class="content" >
              <div class="row d-flex flex-row-reverse">
                <div class="col-lg-6 content-left">
                  <div class="block text-center logo-wrapper">
                    <img
                      src="../../assets/auth/images/spectorly-logo.svg"
                      alt="Spectorly"
                      class="logo"
                    />
                  </div>
                  <div class="block text-center banner-wrapper">
                    <img src="../../assets/auth/images/icon-auth-banner.svg" alt="Auth banner" />
                  </div>

                  <div class="note sub-title-2">
                    Placez l’humain au coeur de votre Stratégie de
                    <span>Cyberdéfence</span>
                  </div>
                </div>
                <transition-group name="fadeY"  mode="out-in">
                <div class="col-lg-6 content-right" >
                  <div v-if="!registrationDone" >
                    <div class="form-2 relative form-auth form-auth--col form-auth-signup" style="z-index: 9">
                      <div class="form-auth-head">
                        <h2 ><span class="auth-form-header-title"><e >Inscription</e> <small v-if="registrationDone" class="text-success cfa-bold">terminée </small></span></h2>
                        <div class="separator" ></div>
                      </div>
                      <div id="form-ind" class="form-auth-inputs-signup" >
                        <div class="form-group">
                          
                          <modern-input @inputChange="(e)=>{this.email = e}"  :syncField="syncTime" placeholder="Veuillez entrer votre adresse email" errorText="Champ requis" uid="cfa-email-bloc" type="email"></modern-input>
                        </div>
                        <div class="" v-if="incorrect" >L'adresse e-mail existe déjà. Veuillez vous connecter ou réinitialiser votre mot de passe.

                        </div>
                        <div class="form-group">
                          <!-- <label>Votre Nom </label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Veuillez entrer votre nom"
                            v-model="lastname"
                          /> -->
                          <modern-input @inputChange="(e)=>{this.lastname = e}"  :syncField="syncTime" placeholder="Veuillez entrer votre nom" errorText="Champ requis" uid="cfa-lastname-bloc" type="text"></modern-input>
                        </div>
                        <div class="form-group">
                          <!-- <label>Votre Prénom</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Veuillez entrer votre adresse prénom"
                            v-model="firstname"
                          /> -->
                          <modern-input @inputChange="(e)=>{this.firstname = e}"  :syncField="syncTime" placeholder="Veuillez entrer votre adresse prénom" errorText="Champ requis" uid="cfa-firstname-bloc" type="text"></modern-input>
                        </div>
                        <div class="form-group">
                          <phone-input @inputChange="catchPhoneInput" :syncField="syncTime" placeholder="Votre numéro de téléphone" errorText="Champ requis" uid="cfa-phone-org-bloc2" type="text"></phone-input>
                        </div>
                        <div class="">
                          <h5 class="text-title" >Type de compte</h5>
                          <div class="d-flex align-items-center justify-content-between mt-1">
                            
                            <div class="d-flex align-items-center account-type-block text-1" id="ind-block">
                              <input @change="getSubscriptionType" type="radio" name="account_type"  value="individual" id="ind" class="input-select-adj"/>
                              <label for="ind">Personnel</label>
                            </div>
                            <div class="d-flex align-items-center account-type-block" id="org-block">
                              <input @change="getSubscriptionType" type="radio" name="account_type" value="organisation" id="org" class="input-select-adj"/>
                              <label for="org">Organisation/Entreprise</label>
                            </div>
                          </div>
                        </div>
                        <div class="">
                            <label class="d-flex align-items-center cursor-pointer text-2">
                              <input v-model="privacyCheck" id="customCheckLogin" type="checkbox" class="form-checkbox border-0 rounded ml-1 w-5 h-5 ease-linear transition-all duration-150" style="margin-right: .5em;"/>
                              <span class="ml-2 text-2" :style="{ color: 'black', border: border }">
                                J'accepte les <a href="http://spectorly/com/cgu" target="_blank" class="text-emerald-5001 link" style="color: var(--primary-color);">CGU</a> et 
                                <a href="/generals-conditions" target="_blank" class="text-emerald-5001 link" >
                                  politique de confidentialité
                                </a>
                              </span>
                          </label>
                        </div>
                      </div>
                      <div id="form-org" class="d-none auth-form-content">
                        <p class="mb-5" style="color: black; font-weight: 400;">&nbsp;Informations de votre organisation

                        </p>
                        <div class="mt-3 pb-2 ">
                          <modern-input @inputChange="(e)=>{this.register_org_name = e}"  :syncField="syncTime" placeholder="Nom de votre organisation/entreprise" errorText="Champ requis" uid="cfa-org-bloc-name" type="text"></modern-input>
                        </div>

                        <div class="mt-5 form-group">
                          <select class="form-control" v-model="selectedActivity" style="border-radius: 6px; padding-right: 68px; font-size: 15px;" errorText="Champ requis" uid="cfa-act-bloc">
                            <option value="" selected disabled>Choisissez votre domaine d'activité</option>
                            <option v-for="activity in activityOptions" :value="activity.value" :key="activity.value">{{ activity.text }}</option>
                          </select>
                        </div>

                        <!-- <div class="mt-5 pb-2">
                          <modern-input @inputChange="(e)=>{this.register_org_sector = e}" :syncField="syncTime" placeholder="Secteur d'activité" errorText="Champ requis" uid="cfa-act-bloc" type="text"></modern-input>
                        </div> -->
                        <div class="mt-5 d-none">
                          <modern-input @inputChange="(e)=>{this.register_org_mail = e}" :syncField="syncTime" placeholder="Mail de contact" errorText="Champ requis" uid="cfa-mail-bloc" type="email"></modern-input>
                        </div>
                        <div class="mt-5 pb-2 d-none">
                          <phone-input @inputChange="catchPhoneInputOrg" :syncField="syncTime" placeholder="Téléphone Organisation" errorText="Champ requis" uid="cfa-phone-org-bloc2" type="text"></phone-input>
                        </div>
                        <div class="mt-5 d-flex d-none align-items-center row">
                            <div class="col-6">
                                <modern-input @inputChange="(e)=>{this.register_org_web = e}" :syncField="syncTime" :required="false" placeholder="URL Site web" errorText="" uid="cfa-web-bloc" type="text"></modern-input>
                            </div>
                            <div class="col-6">
                                <modern-input @inputChange="(e)=>{this.register_org_logo = e}" :syncField="syncTime" :required="false" placeholder="URL Logo" errorText="" uid="cfa-logo-bloc" type="text"></modern-input>
                            </div>
                        </div>
                      
                      </div>
                      <div class="form-group submit-ctn">
                        <button
                        @click="tryRegisterUser"
                          type="submit"
                          class="c-btn c-btn--secondary block w-100 spect-btn"
                          id="submitForm1"
                        >
                          <span v-if="!waitingAPIResponse">M'inscrire</span>
                          <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 30px;"/>
                        </button>
                      </div>

                      <div class="form-group">
                        <button
                        @click="toNextStep('next')" type="submit" id="submitForm2"
                          class=" d-none c-btn c-btn--secondary block w-100"
                          
                        >
                        <span>Suivant <i class="fa fa-angle-double-right"></i></span>
                  
                        </button>
                      </div>
                      <div class="form-group">
                        <button
                        @click="tryRegisterOrg"
                          type="submit"
                          class=" d-none c-btn c-btn--secondary block w-100"
                          id="submitForm3"
                        >
                        <span v-if="!waitingAPIResponse">M'inscrire</span>
                          <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 30px;"/>
                        </button>
                      </div>

                      <p class="text-center text-2 mt-3">
                        J'ai déjà un compte
                        <a href="/signin" id="exc2" class="cursor-pointer text-2"
                          ><span>Me connecter</span></a
                        >
                      </p>
                    </div>
                  </div>

                  <div v-else class="text-center">
              <!-- image success -->
              <!--<img src="@/assets/img/svg/checked0.svg" alt="" class="mb-2" style="width: 55%;"/>-->
              <video width="256" height="256" preload="none" style="background: transparent url('https://cdn-icons-png.flaticon.com/512/8717/8717946.png') 50% 50% / fit no-repeat;" autoplay="autoplay" loop="true" muted="muted" playsinline="">
                <source src="https://cdn-icons-mp4.flaticon.com/512/8717/8717946.mp4" type="video/mp4">
              </video>

              <label class="extra-msg mb-2 p-4" style="border-radius: 4px;font-size:15px;">Vérifiez votre boîte email pour activer votre compte. Merci!</label>
              <div class="auth-form-actions1">
                <p style="color: white;">
                  J'ai pas reçu le mail&nbsp;
                  <a href="#" style="color: white;" @click="resentActivationMail">Renvoyer le mail d'activation</a>
                </p>
                
                        
                        <a href="/login"  type="button" target="" rel="noopener" class="neutral inverted light oauth-button-light" style="text-decoration: none;"
                          ><span>Me connecter</span></a
                        >
                      
              </div>
                  </div>
                </div>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container
      <transition name="fadeY" appear mode="out-in">
      <alert v-if="alertMe" :status="gAlertType" :message="gAlertMessage"></alert>
    </transition> -->
    </main>
  </template>
  
  <script>
 import ModernInput from '@/components/shared/input/ModernInput.vue'
import PhoneInput from '@/components/shared/input/PhoneInput.vue'
// import { guestAPI } from '@/axios-api.js'
import axios from "axios";
  // import Alert from '@/components/shared/alert/Alert.vue'
  
  export default {
    name: 'LoginView',
    components: {
      ModernInput,
      // Alert,
      "phone-input":PhoneInput,
    },
    data () {
      return {
        email: '',
        firstname: '',
        lastname: '',
        phone: null,
        register_org_name: '',
        register_org_sector: '',
        register_org_mail: 'org@contact.mail',
        register_org_web: 'https://website.domaine',
        register_org_logo: '',
        register_org_phone: null,
        alertMe: false,
        gAlertMessage: '',
        gAlertType: '',
        incorrect:false,
        waitingAPIResponse: false,
        waitingAPIResponse2: true,
        registrationDone: false,
        wait: false,
        syncTime: null,
        border: null,
        privacyCheck: null,
        subscriptionType: null,
        color: null,
        selectedActivity: '',
        activityOptions: [],
      }
    },
    methods: {
      displayError(error, type='alert-ok', time=5000) {
          this.gAlertMessage = error
          this.gAlertType = type
          this.alertMe = true
          setTimeout(() => {
              this.alertMe = false
          }, time);
      },
      catchPhoneInput (data) {
        this.phone = data;
      },
      catchPhoneInputOrg (data) {
        this.register_org_phone = data;
        console.log(this.register_org_phone);
      },
      beep() {
        var snd = new Audio("data:audio/wav;base64,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");
        snd.play();
      },
      onlyNumber(evt) {
        var ASCIICode = (evt.which) ? evt.which : evt.keyCode
        if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
          this.beep();
          evt.preventDefault();
        }
        return true;
      },
      tryRegisterUser () {
        if(this.privacyCheck == null) {
            this.border = "#fb3737";
            return;
        }
        else{
            this.border= "#000"
        }
  
        if(this.subscriptionType == null) {
            this.color = "#fb3737";
            return;
        }
        else{
            this.color= "none"
        }
  
        if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email) || this.firstname == '' || this.lastname == '' || this.phone == null ) {
          this.displayError('Oups ! Veuillez remplir les champs convenablement.', 'alert-no');
          this.syncTime = Date.now().toString()
        }
        else{
          console.log(this.phone.country)
          this.waitingAPIResponse = true
          axios.post(`${process.env.VUE_APP_BASE_URL}accounts/register/individual`,
              {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                country: this.phone.country,
                phone: this.phone.phone.replaceAll('-', ''),
              })
              .then(response => {
                if(response.status == 201) {
                  this.$emit('register', `${this.firstname} ${this.register_country}`)
                  this.displayError(response.data.message, 'alert-yes', 7000)
                  this.registrationDone = true;
                }
                else {
                  this.displayError('Oups ! something went wrong.', 'alert-no')
                  this.waitingAPIResponse = false
                }
                localStorage.setItem('guest_email', this.email);
              })
              .catch(error => {
                localStorage.removeItem('token')
                if (error.response) {
                  this.incorrect=true;
                  this.displayError(error.response.data.data.email || error.response.data.message, 'alert-no', 10000)
                }
                else if (error.request) {
                  this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
                }
                else {
                  this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
                }
                this.waitingAPIResponse = false
              })
        }
      },
      tryRegisterOrg () {
        // console.log(this.register_org_name);
  
        if(this.privacyCheck == null) {
            this.border = "#fb3737";
            return;
        }
        else{
            this.border= "none"
        }
  
        if(this.subscriptionType == null) {
            this.color = "#fb3737";
            return;
        }
        else{
            this.color= "none"
        }
  
        if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email) || this.firstname == '' || this.lastname == '' || this.phone == null ||
            this.register_org_name == '' || this.register_org_sector == '' || this.register_org_mail == '' ) {
          this.displayError('Oups ! Veuillez remplir les champs convenablement.', 'alert-no');
          this.syncTime = Date.now().toString()
        }
        else{
          this.waitingAPIResponse = true
          axios.post(`${process.env.VUE_APP_BASE_URL}accounts/register/manager`,
              {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                country: this.phone.country,
                phone: this.phone.phone.replaceAll('-', ''),
                id: this.id,
                organisation: {
                  name: this.register_org_name,
                  country: this.phone.country,
                  address: '',
                  phone: this.phone.phone.replaceAll('-', ''),
                  email: this.register_org_mail,
                  website: this.register_org_web,
                  logo: this.register_org_logo
                },
                activity: this.register_org_sector,
              })
              .then(response => {
                if(response.status == 201) {
                  console.log("Code: ", this.phone)
                  this.$emit('register', `${this.firstname}`)
                  this.displayError(response.data.message, 'alert-yes', 7000)
                  this.registrationDone = true;
                  localStorage.setItem('guest_email', this.email);
                }
                else {
                  this.displayError('Oups ! something went wrong.', 'alert-no')
                  this.waitingAPIResponse = false
                }
              })
              .catch(error => {
                localStorage.removeItem('token')
                if (error.response) {
                   this.incorrect=true;
                  this.displayError(error.response.data.data.email || error.response.data.data.organisation_name || error.response.data.message, 'alert-no', 10000)
                }
                else if (error.request) {
                  this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
                }
                else {
                  this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
                }
                this.waitingAPIResponse = false
              })
        }
      },
      resentActivationMail () {
        axios.post(`${process.env.VUE_APP_BASE_URL}accounts/resend-email-activate-account/`,
        {
          email: localStorage.guest_email,
        })
        .then(response => {
          if(response.status == 200) {
            this.$emit('resent')
            this.displayError("Le mail d'activation vous à été envoyé à nouveau. Veuillez consulter votre boite mail.", 'alert-yes', 8000)
            this.wait = true;
          }
          else {
            this.displayError('Oups ! something went wrong.', 'alert-no')
          }
        })
        .catch(error => {
          localStorage.removeItem('token')
          if (error.response) {
            this.displayError(error.response.data.message, 'alert-no', 10000)
          }
          else if (error.request) {
            this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
          }
          else {
            this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
          }
          this.waitingAPIResponse = false
        })
      },
      getSubscriptionType (e) {
        let type = e.target.value
        this.subscriptionType = type
        if(type == 'organisation') {
          document.getElementById('submitForm1').classList.add('d-none')
          document.getElementById('submitForm2').classList.remove('d-none')
          document.getElementById('submitForm3').classList.add('d-none')
        }
        else{
          document.getElementById('submitForm1').classList.remove('d-none')
          document.getElementById('submitForm2').classList.add('d-none')
          document.getElementById('submitForm3').classList.add('d-none')
        }
        
        this.getActivity();
      },
      toNextStep (direction='next') {
        if(this.privacyCheck == null) {
            this.border = "#fb3737";
            return;
        }
        else{
            this.border= "#000"
        }
  
        if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email) || this.firstname == '' || this.lastname == '' || this.phone == null ) {
          this.displayError('Oups ! Veuillez remplir les champs pour continuer.', 'alert-no');
          this.syncTime = Date.now().toString()
        }
        else{
          if(direction == 'next') {
            document.getElementById('form-ind').classList.add('d-none')
            document.getElementById('form-org').classList.remove('d-none')
            document.getElementById('submitForm2').classList.add('d-none')
            document.getElementById('submitForm3').classList.remove('d-none')
            
            document.getElementById('exc2').classList.add('d-none')
          }
          else{
            document.getElementById('form-ind').classList.remove('d-none')
            document.getElementById('form-org').classList.add('d-none')
            document.getElementById('submitForm3').classList.add('d-none')
            document.getElementById('submitForm1').classList.add('d-none')
            document.getElementById('submitForm2').classList.remove('d-none')
            
            document.getElementById('exc2').classList.remove('d-none')
          }
        }
      },
      
      getActivity() {
        this.waitingAPIResponse = true;
        this.waitingAPIResponse2 = true;
        axios.get(`${process.env.VUE_APP_BASE_URL}activity`)
          .then(response => {
            if (response.status === 200) {
              const activities = response.data.results;
              this.staticActivity = activities;
              this.activityOptions = activities.map(activity => ({
                value: activity.id,
                text: activity.name
              }));
            } else {
              //let msg = 'Oups ! something went wrong.';
              //this.alertString = `${msg}|alert-no|5000::` + Date.now();
            }
            setTimeout(() => {
              this.waitingAPIResponse = false;
              this.waitingAPIResponse2 = false;
            }, 2000);
          })
          .catch(error => {
            if (error.response) {
              //this.alertString = `Activité non disponible|alert-no|10000::` + Date.now();
            } else if (error.request) {
              //let msg = 'The request was made but no response was received. Please check your network.';
              //this.alertString = `${msg}|alert-no|8000::` + Date.now();
            } else {
              //let msg = 'Oups ! something went wrong.';
              //this.alertString = `${msg}|alert-no|5000::` + Date.now();
            }
            this.waitingAPIResponse = false;
            this.waitingAPIResponse2 = false;
          });
        },
    },
    watch: {
      selectedActivity(newActivity) {
        this.register_org_sector = newActivity;
        // console.log(newActivity);
      },
    },
    mounted() {
      let $ = window.jQuery;
      $(document).ready(function() {
        $('.account-type-block').hover(function() {
          let $tooltip = $('<div class="g-tooltip"></div>');
          if (this.id == 'ind-block') {
            $tooltip.text('Créez un compte individuel et suivez votre parcours en solo.');
          } else {
            $tooltip.text('Créer votre compte entreprise et  ajouter les membre de votre organisation”');
          }
          $('body').append($tooltip);
          $tooltip.css({
            left: $(this).offset().left + $(this).width() - 85,
            top: $(this).offset().top + 40
          });
          $tooltip.show();
        }, function() {
          $('.g-tooltip').remove();
        });
      });
  
      this.waitingAPIResponse2 = true
      axios.get(`${process.env.VUE_APP_BASE_URL}pub?key=INSCRIPTION`).then(response => {
        if(response.status == 200) {
          this.pub = response.data[0]
        }
        else{
          console.log('Something went wrong !')
        }
        this.waitingAPIResponse2 = false
        // setTimeout(() => {
        //     let img = document.getElementById('pubImg');
        //     console.log(this.pickImageColor(img))
        //
        //     let averageColor = this.calculateAverageColor(img)
        //
        //     document.querySelector('.rightBlock').style.backgroundColor = averageColor;
        // }, 3000)
      }).catch(() => {
        console.log('Something went wrong !')
        this.waitingAPIResponse2 = false
      });
    }
  }
  </script>
  
  